module.exports = __webpack_public_path__ + "img/top_highlight.ad68fc27.png";